export default "__VITE_ASSET__BKwC90kB__"